import { Button, ButtonGroup } from '@mui/material';
import {
    ArrowBack,
    ArrowForward,
    ArrowDownward,
    ArrowUpward,
} from '@mui/icons-material';
import './BidirectionalArrows.scss';

/**
 * FirstButton represent the top/left button
 * SecondButton represent the bottom/right button
 * @param {{
 *  direction: ('leftRight'|'upDown')
 *  buttonGroupProps?: (import('@mui/material').ButtonGroupProps|undefined);
 *  firstButtonProps?: (import('@mui/material').ButtonProps|undefined);
 *  secondButtonProps?: (import('@mui/material').ButtonProps|undefined);
 *  disabled?: boolean;
 * }} param0
 */
const BidirectionalArrows = ({
    direction = 'leftRight',
    buttonGroupProps,
    firstButtonProps,
    secondButtonProps,
    disabled = false,
}) => {
    const buttonClassName = 'bidirectional-arrows--button';
    const iconClassName = 'bidirectional-arrows--arrow-icon';

    let firstIcon = <ArrowBack className={iconClassName} />;
    let secondIcon = <ArrowForward className={iconClassName} />;

    if (direction === 'upDown') {
        firstIcon = <ArrowUpward className={iconClassName} />;
        secondIcon = <ArrowDownward className={iconClassName} />;
    }

    return (
        <div className="core--bidirectional-arrows">
            <ButtonGroup
                disabled={disabled}
                className="bidirectional-arrows--button-group"
                {...buttonGroupProps}
            >
                <Button
                    className={buttonClassName}
                    {...firstButtonProps}
                >
                    {firstIcon}
                </Button>
                <Button
                    className={buttonClassName}
                    {...secondButtonProps}
                >
                    {secondIcon}
                </Button>
            </ButtonGroup>
        </div>
    );
};

export default BidirectionalArrows;
